import { render, staticRenderFns } from "./ProjectFinanceForm.vue?vue&type=template&id=f35d8052&scoped=true&"
import script from "./ProjectFinanceForm.vue?vue&type=script&lang=js&"
export * from "./ProjectFinanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35d8052",
  null
  
)

export default component.exports